import React from "react";

const StableLabel = ({ children, alternatives }) => (
  <span className="stable-label">
    <span>{children}</span>
    {alternatives.map((text, index) => (
      <span key={index} className="stable-label-alt" aria-hidden="true">
        {text}
      </span>
    ))}
  </span>
);

export default StableLabel;
